
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/step-1",
      function () {
        return require("private-next-pages/register/step-1/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register/step-1"])
      });
    }
  